import {EventBus} from "./events";

require('./bootstrap');
require('./backend/plugins');

require('./backend/_menu');

// require('./_menu');
require('./_sidebar');
window.Vue = require('vue').default;

require('./backend/UI/flashmessages');

// Extra;
let languageString = document.head.querySelector('meta[name="languages"]').content;

if (languageString) {
    window.languages = JSON.parse(languageString);
} else {
    window.languages = [];
}

// Vue components

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('tab', require('./backend/UI/components/Tab.vue').default);
Vue.component('tabs', require('./backend/UI/components/Tabs.vue').default);
Vue.component('meta-description', require('./backend/UI/components/MetaDescription.vue').default);
Vue.component('meta-title', require('./backend/UI/components/MetaTitle.vue').default);
Vue.component('ckeditor', require('./backend/UI/components/CKEditor.vue').default);
Vue.component('composer', require('./backend/Composer/Composer').default);
Vue.component('vue-select', require('./backend/UI/components/VueSelect.vue').default);

Vue.component('related-products-select', require('./backend/components/RelatedProductsSelect').default);
Vue.component('combideal-products-select', require('./backend/components/CombidealProductsSelect').default);
Vue.component('related-articles-select', require('./backend/components/RelatedArticlesSelect').default);
Vue.component('tag-manager', require('./backend/components/TagManager').default);
Vue.component('content-type-manager', require('./backend/components/ContentTypeManager').default);
Vue.component('property-option-selector', require('./backend/components/PropertyOptionsSelect').default);
Vue.component('address-auto-complete', require('./backend/components/AddressAutoComplete').default);

// Vue.component('article-tag-manager', require('./backend/components/ArticleTagManager').default);
// Vue.component('brand-selector', require('./backend/components/BrandSelector').default);
// Vue.component('location-type-selector', require('./backend/components/LocationTypeSelector').default);
// Vue.component('lat-lng-selector', require('./backend/components/LatLngSelector').default);

Vue.component('site-category-select', require('./backend/components/SiteCategorySelect').default);
Vue.component('site-product-feature-select', require('./backend/components/SiteProductFeatureSelect').default);
Vue.component('debtor-select', require('./backend/components/DebtorSelect').default);
Vue.component('internal-order', require('./backend/components/InternalOrder').default);
Vue.component('address-select', require('./backend/components/AddressSelect').default);
Vue.component('author-select', require('./backend/components/AuthorSelect.vue').default);
Vue.component('author-list', require('./backend/components/AuthorList.vue').default);
Vue.component('create-edit-order', require('./backend/components/CreateEditOrder').default);
Vue.component('pricegroup', require('./backend/components/Pricegroup').default);
// Vue.component('material-select', require('./backend/components/MaterialSelect.vue').default);
// Vue.component('color-select', require('./backend/components/ColorSelect.vue').default);

// Vue.component('showcase-manager', require('./backend/components/ShowcaseManager.vue').default);
// Vue.component('showcase-highlight', require('./backend/components/ShowcaseHighlight.vue').default);
// Vue.component('property-manager', require('./backend/components/PropertyManager.vue').default);

// Vue.component('debtor-order-table', DebtorOrderTable);

// Vue.component('series-select', SeriesSelect);
// Vue.component('categories-select', CategoriesSelect);
// Vue.component('filter-pages-select', FilterPageSelect);
//
// Vue.component('showcase-select', require('./backend/components/ShowcaseSelect.vue').default);

Vue.component('move-reviews-product-select', require('./backend/components/MoveReviewsProductSelect.vue').default);

// Store
import Vuex from "vuex";
import {composer} from './backend/Composer/store';

const store = new Vuex.Store({
    modules: {
        composer
    },
    state: {
        csrfToken: window.axios.defaults.headers.common['X-CSRF-TOKEN'],
        languages: window.languages,
    },
    actions: {
        //
    }
});

//observer for fancybox iframe data
const iframeMonitor = Vue.observable({
    iframeData: null,
    iframeAddressData: null,
});

Object.defineProperty(window, 'iframeData', {
    get () {
        return iframeMonitor.iframeData
    },
    set (data) {
        iframeMonitor.iframeData = data
    }
});

Object.defineProperty(window, 'iframeDataAddress', {
    get () {
        return iframeMonitor.iframeDataAddress
    },
    set (data) {
        iframeMonitor.iframeDataAddress = data
    }
});

window.onload = function () {
    const app = new Vue({
        el: '#app',
        store,
        mounted() {
            flash_session();
        },
    });
}
window.refreshAddresses = function(addressId, type){
    EventBus.$emit('refreshAddresses', addressId, type);
}
